import { itemLetter } from "./toolBox";
import { useSurveyCardsStore } from "@stores/survey/surveyCards";
import { storeToRefs } from "pinia";

export const generateCardLabel = (
  cardReference,
  handleMatrix = true,
  handleCustom = true,
  handleOUserAttributes = true,
) => {
  const surveyCardsStore = useSurveyCardsStore();
  const { cards } = storeToRefs(surveyCardsStore);
  const cardToken = typeof cardReference === "string" ? cardReference : cardReference?.card_token;

  if (["next_card", "no_redirection"].includes(cardToken)) return computedRedirectionLabel(cardToken);

  const card = cards.value.find((card) => card.token === cardToken);

  if (card != null) {
    if (card.type === "q_matrix" && handleMatrix) return computedItemLabel(card, cardReference);
    else if (card.type === "o_custom" && handleCustom) return computedCustomLabel(card, cardReference);
    else if (card.type === "o_user_attributes" && handleOUserAttributes) return computedUALabel(card);
    else return computedLabel(card);
  } else {
    return "";
  }
};

const computedLabel = (card) => `${card.name || "(untitled)"}`;
const computedUALabel = (card) => `UA. ${card.specs.attribute_name || "(untitled)"}`;
const computedItemLabel = (card, cardReference) => {
  const itemIndex = card.specs.items.findIndex((item) => item.token === cardReference.item_token);
  const letter = itemLetter(itemIndex) || "";
  return `${card.name}_ITEM_${letter}`;
};
const computedCustomLabel = (card, cardReference) =>
  `UA. ${card.specs.attribute_name}${cardReference.user_attribute || ""}`;
const computedRedirectionLabel = (cardReference) => {
  const destinationLabels = {
    next_card: "Next card",
    no_redirection: "No redirection",
  };
  return destinationLabels?.[cardReference] ?? "";
};
